/**
 * Manages display of alert messages in predefined containers.
 */
class Alerts {
  /** @type {AlertType[]} */
  types = ['error', 'warning', 'success'];

  /** @type {Partial<AlertMap>} */
  map = {};

  /**
   * Find alert containers and bind bulk show on DOM load.
   */
  constructor() {
    this.types.forEach(type => {
      const container = document.getElementById(`alert-${type}`);
      if (!container) return;
      this.map[type] = {
        ul: container.querySelector('ul'),
        wrapper: container
      };
    });

    document.addEventListener('DOMContentLoaded', () => {
      this.showBulk(window.FLASH_MESSAGES || {});
      window.FLASH_MESSAGES = {};
    });
  }

  /**
   * Display messages for a specific alert type.
   * @param {AlertType} type - Category to update.
   * @param {string[]} messages - Array of messages to display.
   */
  show(type, messages) {
    const entry = this.map[type];
    if (!entry?.ul) return;
    entry.ul.innerHTML = messages.map(m => `<li>${m}</li>`).join('');
    entry.wrapper.classList.add('visible');
  }

  /**
   * Clear messages from all alert types.
   */
  clear() {
    this.types.forEach(type => {
      const entry = this.map[type];
      if (!entry?.ul) return;
      entry.ul.innerHTML = '';
      entry.wrapper.classList.remove('visible');
    });
  }

  /**
   * Show multiple alerts based on a type-to-messages map.
   * @param {Object.<AlertType, string|string[]>} obj - Messages keyed by type.
   */
  showBulk(obj) {
    Object.entries(obj).forEach(([type, msgs]) => {
      if (!msgs) return;
      const arr = Array.isArray(msgs) ? msgs : [msgs];
      this.show(/** @type {AlertType} */ (type), arr);
    });
  }
}

window.alerts = new Alerts();
export default window.alerts;